import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import '../clientviews/staffmanagment/user.css';
import { FaArrowLeft, FaCheck } from "react-icons/fa";
import 'bootstrap/dist/css/bootstrap.min.css';
import './hospitaldetails.css';
import api from '../../service/caller';
import { usePermissions } from '../../contexts/PermissionContext';

const HospitalDetails = () => {
    const { hospitalId } = useParams();
    const [hospital, setHospital] = useState(null);
    const [departments, setDepartments] = useState([]);
    const [specialities, setSpecialities] = useState([]);
    const [services, setServices] = useState([]);
    const navigate = useNavigate();
    const { UserData } = usePermissions();

    useEffect(() => {
        const fetchHospital = async () => {
            try {
                const response = await api.get(`/api/gethospital/${hospitalId}`);
                setHospital(response.data);
            } catch (error) {
                console.error("Erreur lors du chargement des détails :", error);
            }
        };
        fetchHospital();
    }, [hospitalId]);

    useEffect(() => {
        const fetchDepartments = async () => {
            try {
                if (!hospitalId) return;
                const response = await api.get(`/api/departments/hospital/${hospitalId}`, {
                    headers: {
                        'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
                    }
                });
                setDepartments(response.data.data);
            } catch (error) {
                console.error('Erreur lors de la récupération des départements:', error);
            }
        };
        fetchDepartments();
    }, [hospitalId]);

    useEffect(() => {
        const fetchSpecialities = async () => {
            try {
                if (!hospitalId) return;
                const response = await api.get(`/api/specialities/hospital/${hospitalId}`, {
                    headers: {
                        'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
                    }
                });
                setSpecialities(response.data.data);
            } catch (error) {
                console.error('Erreur lors de la récupération des Specialites:', error);
            }
        };
        fetchSpecialities();
    }, [hospitalId]);

    useEffect(() => {
        const fetchServices = async () => {
            try {
                if (!hospitalId) return;
                const response = await api.get(`/api/services/hospital/${hospitalId}`, {
                    headers: {
                        'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
                    }
                });
                setServices(response.data.data);
            } catch (error) {
                console.error('Erreur lors de la récupération des Services:', error);
            }
        };
        
        // Animation des éléments au chargement de la page
        const animateElements = () => {
            const elements = document.querySelectorAll('.hp-fade-in');
            elements.forEach((element, index) => {
                setTimeout(() => {
                    element.classList.add('hp-visible');
                }, 100 * index);
            });
        };
        
        fetchServices();
        
        // Déclencher l'animation après un court délai pour s'assurer que tout est chargé
        setTimeout(() => {
            animateElements();
        }, 300);
    }, [hospitalId]);

    if (!hospital) return <div>Loading...</div>;
    
    return (
        <div className="hp-container">
            <div className='hp-wrapper'>
                <div className='hp-sidebar'>
                    <button className="hp-back-button hp-fade-in" onClick={() => navigate(-1)}>
                        <FaArrowLeft /> Retour
                    </button>
                    <div className="hp-profile-header hp-fade-in">
                        <div className="hp-profile-image">
                        <img src={UserData.hospital_id[0].picture} alt="tete" className="tete" />
                        </div>
                    </div>
                    <div className="hp-divider hp-fade-in">
                        <div className="hp-solid-line"></div>
                        <div className="hp-dotted-line"></div>
                    </div>
                </div>
                
                <div className='hp-main-content'>
                    <div className="hp-info-card hp-fade-in">
                        <div className="hp-info-grid">
                            <div className="hp-info-item">
                                <label className="hp-label">Nom de l'hôpital:</label>
                                <p className="hp-value">{hospital.hospital_name}</p>
                            </div>
                            <div className="hp-info-item">
                                <label className="hp-label">Adresse:</label>
                                <p className="hp-value">{hospital.hospital_country}, {hospital.hospital_city}, {hospital.hospital_state_province}</p>
                            </div>
                            <div className="hp-info-item">
                                <label className="hp-label">Téléphone:</label>
                                <p className="hp-value">{hospital.hospital_phone} / {hospital.hospital_phone2}</p>
                            </div>
                            <div className="hp-info-item">
                                <label className="hp-label">Devise:</label>
                                <p className="hp-value">{hospital.hospital_currency}</p>
                            </div>
                            <div className="hp-info-item">
                                <label className="hp-label">Créé le:</label>
                                <p className="hp-value">{hospital.createdAt}</p>
                            </div>
                        </div>
                    </div>

                    <div className="hp-section hp-fade-in">
                        <h6 className="hp-section-title">Départements:</h6>
                        <div className="hp-tags-container">
                            {departments?.length > 0 ? (
                                departments.map((dept, index) => (
                                    <span key={dept._id} className="hp-tag hp-badge" style={{animationDelay: `${index * 0.1}s`}}>
                                        <span className="hp-icon"><FaCheck /></span>
                                        {dept.name}
                                    </span>
                                ))
                            ) : (
                                <p className="hp-empty-message">Aucun département disponible</p>
                            )}
                        </div>
                    </div>

                    <div className="hp-section hp-fade-in">
                        <h6 className="hp-section-title">Spécialités:</h6>
                        <div className="hp-tags-container">
                            {specialities?.length > 0 ? (
                                specialities.map((speciality, index) => (
                                    <span key={speciality._id} className="hp-tag hp-badge" style={{animationDelay: `${index * 0.1}s`}}>
                                        <span className="hp-icon"><FaCheck /></span>
                                        {speciality.name}
                                    </span>
                                ))
                            ) : (
                                <p className="hp-empty-message">Aucune spécialité disponible</p>
                            )}
                        </div>
                    </div>

                    <div className="hp-section hp-fade-in">
                        <h6 className="hp-section-title">Services:</h6>
                        <div className="hp-tags-container">
                            {services?.length > 0 ? (
                                services.map((service, index) => (
                                    <span key={service._id} className="hp-tag hp-badge" style={{animationDelay: `${index * 0.1}s`}}>
                                        <span className="hp-icon"><FaCheck /></span>
                                        {service.name}
                                    </span>
                                ))
                            ) : (
                                <p className="hp-empty-message">Aucun service disponible</p>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HospitalDetails;
